module.exports = __webpack_public_path__ + "static/media/ic-content-copy.47a63510.svg";